document.addEventListener('DOMContentLoaded', function() {
  var extremeBox   = document.getElementById('ttExtremeBox');
  var checklist    = document.querySelector('.tt-entry-checklist');
  var waiverAgree  = document.getElementById('ttWaiverAgree');
  var submitBtn    = document.getElementById('ttSubmitBtn');
  var errorMsg     = document.getElementById('ttErrorMsg');
  var provON       = document.getElementById('ttProvON');
  var provQC       = document.getElementById('ttProvQC');
  var selectedProv = '';

  if (!checklist || !extremeBox || !waiverAgree || !submitBtn) return;

  // Entry checkboxes — event delegation so Extreme Box works after unlock
  checklist.addEventListener('click', function(e) {
    var item = e.target.closest('.tt-entry-check-item');
    if (!item || item.classList.contains('locked')) return;
    item.classList.toggle('checked');
    var threeBoxChecked = document.querySelector('[data-entry="threebox"]').classList.contains('checked');
    if (threeBoxChecked) {
      extremeBox.classList.remove('locked');
    } else {
      extremeBox.classList.add('locked');
      extremeBox.classList.remove('checked');
    }
  });

  // Province selection
  provON.addEventListener('click', function() {
    selectedProv = 'Ontario';
    provON.classList.add('sel-on');
    provQC.classList.remove('sel-qc');
  });
  provQC.addEventListener('click', function() {
    selectedProv = 'Quebec';
    provQC.classList.add('sel-qc');
    provON.classList.remove('sel-on');
  });

  // Waiver toggle
  waiverAgree.addEventListener('click', function() {
    waiverAgree.classList.toggle('agreed');
  });

  // Submit
  submitBtn.addEventListener('click', function() {
    var teamName = document.getElementById('ttTeamName').value.trim();
    var captain  = document.getElementById('ttCaptain').value.trim();
    var phone    = document.getElementById('ttPhone').value.trim();
    var email    = document.getElementById('ttEmail').value.trim();
    var waiverOk = waiverAgree.classList.contains('agreed');

    if (!teamName || !captain || !phone || !email || !selectedProv || !waiverOk) {
      errorMsg.style.display = 'block';
      return;
    }
    errorMsg.style.display = 'none';

    // Build summary
    var entries = document.querySelectorAll('.tt-entry-check-item.checked');
    var total = 0;
    var html = '';
    html += '<div class="tt-step2-summary-row"><span>Team</span><strong>' + teamName + '</strong></div>';
    html += '<div class="tt-step2-summary-row"><span>Captain</span><strong>' + captain + '</strong></div>';
    html += '<div class="tt-step2-summary-row"><span>Province</span><strong>Team ' + selectedProv + '</strong></div>';
    entries.forEach(function(el) {
      var name  = el.querySelector('h4').textContent;
      var price = parseInt(el.getAttribute('data-price'));
      total += price;
      html += '<div class="tt-step2-summary-row"><span>' + name + '</span><strong>$' + price + '</strong></div>';
    });
    html += '<div class="tt-step2-summary-row"><span><strong>Total</strong></span><strong>$' + total + '</strong></div>';
    document.getElementById('ttSummary').innerHTML = html;

    // Go to step 2
    document.getElementById('ttStep1Content').style.display = 'none';
    document.getElementById('ttStep2Content').classList.add('show');
    document.getElementById('ttStep1Pill').classList.remove('active');
    document.getElementById('ttStep1Pill').classList.add('completed');
    document.getElementById('ttStep2Pill').classList.add('active');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
});